export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      gradient: 'from-teal-500 to-teal-600',
      title: 'AES-256 Encryption',
      description: 'Military-grade encryption protects your data with the same security standards used by governments and financial institutions worldwide.'
    },
    {
      icon: 'ri-flashlight-line',
      gradient: 'from-cyan-500 to-cyan-600',
      title: 'Ultra-Fast Servers',
      description: 'Experience blazing-fast connection speeds with our optimized global server network. Stream, browse, and download without slowdowns.'
    },
    {
      icon: 'ri-eye-off-line',
      gradient: 'from-emerald-500 to-emerald-600',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or store your online activity. Your browsing history remains completely private and anonymous.'
    },
    {
      icon: 'ri-global-line',
      gradient: 'from-teal-500 to-emerald-500',
      title: 'Worldwide Coverage',
      description: 'Access content from anywhere with our extensive network of servers across 50+ countries on six continents.'
    }
  ];

  return (
    <section id="features" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <p className="text-xs font-bold text-teal-600 uppercase tracking-widest mb-4">Features</p>
          <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            Military-Grade Protection<br />
            Made Simple
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white border border-gray-200 rounded-3xl p-8 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${feature.gradient} rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              
              <p className="text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
